import { Global as GlobalComponent } from "@emotion/react";

export default function Fonts() {
  return (
    <GlobalComponent
      styles={`
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-Medium.otf') format('opentype');
          font-weight: 500;
        }
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-Bold.otf') format('opentype');
          font-weight: bold;
        }
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-Black.otf') format('opentype');
          font-weight: extra-bold;
        }
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-Ultra.otf') format('opentype');
          font-weight: black;
        }
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-Book.otf') format('opentype');
          font-weight: normal;
        }
        @font-face {
          font-family: 'Gotham';
          src: url('/fonts/gotham/Gotham-BookItalic.otf') format('opentype');
          font-weight: normal;
          font-style: italic;
        }
        @font-face {
          font-family: 'Northwell';
          src: url('/fonts/northwell/NorthwellVanWijnen.otf') format('opentype');
          font-weight: normal;
        }
    `}
    />
  );
}
